import { http } from '../api/http';
import type { Investment } from '../types/Project';
import { generateTransactionCode } from '../utils/transactionCode';

export interface InvestmentGate {
  canInvest: boolean;
  kycRequired: boolean;
  pldRequired: boolean;
  kycStatus?: 'not_started' | 'pending' | 'approved' | 'rejected';
  pldStatus?: 'not_started' | 'pending' | 'approved' | 'rejected';
  reasons?: string[];
}

type CreateInvestmentPayload = {
  projectId: number | string;
  amount: number;
  transactionCode?: string;
};

export const InvestmentsService = {
  getMyInvestments() {
    return http<Investment[]>('/investments/me');
  },

  getGate() {
    return http<InvestmentGate>('/investments/gate');
  },

  createInvestment(payload: CreateInvestmentPayload) {
    const transactionCode =
      payload.transactionCode ||
      generateTransactionCode({ prefix: 'PF-TX', randomLength: 8, includeTime: true });

    return http<Investment>('/investments', {
      method: 'POST',
      body: {
        projectId: payload.projectId,
        amount: payload.amount,
        transactionCode
      }
    });
  }
};
